import { env } from 'app/lib/env';

export const appStoreUrls = {
  ios: `https://apps.apple.com${!env.IS_PARTAKE ? '/ca' : ''}/app/id${env.APPLE_APP_ID}`,
  android: `https://play.google.com/store/apps/details?id=${env.BUNDLE_ID.replace('.development', '')}`,
};
